import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { CentredSpinner } from '@velove/design-system';
import { AppContext } from '../contexts/AppContext';
import { GLOBAL_FAVICON, GLOBAL_PARTNER } from '../Constants';
import Main from './Main';
import { useTranslation } from 'react-i18next';

const Root = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { packageId } = useParams();
  const { pathname } = useLocation();
  const splitPath = pathname.split('/')[1];

  const [isCssLoading, setIsCssLoading] = useState(true);
  const { partner, settings, setPartnerAndSettings } = useContext(AppContext);

  useEffect(() => {
    if (!packageId) {
      setIsCssLoading(false);
      if (splitPath === 'p') {
        navigate('/p');
      } else {
        navigate('/cs');
      }
    } else if (!['cs', 'p'].includes(splitPath)) {
      navigate('/cs');
    }

    (window as any).fcWidgetMessengerConfig = {
      config: {
        headerProperty: {
          foregroundColor: '#ffffff',
          fontName: 'Arial',
          appName: 'Customer support',
          appLogo:
            settings?.brand?.favicon ||
            'https://d1qb2nb5cznatu.cloudfront.net/startups/i/2473-2c38490d8e4c91660d86ff54ba5391ea-medium_jpg.jpg?buster=1518574527',
          hideChatButton: true
        },
        siteId: packageId
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageId, navigate, settings?.brand?.favicon]);

  const { isFetching } = useQuery({
    queryKey: ['partnerSettings'],
    queryFn: async () => {
      const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/v1/package/${packageId}/settings`);
      return response.data;
    },
    onSuccess: (data) => {
      setPartnerAndSettings(data);

      if (data?.settings?.locales) {
        Object.keys(data.settings.locales).forEach((locale) => {
          i18n.addResourceBundle(locale, 'translation', data.settings.locales[locale]?.translation, true);
        });
      }
    },
    onError: () => {
      console.log('Fetching partner and settings failed');

      if (splitPath === 'p') {
        navigate('/p');
      } else {
        navigate('/cs');
      }
    },
    enabled: !partner?.name
  });

  return (
    <div className="rdg-light">
      <Helmet
        onChangeClientState={(newState, addedTags, removedTags) => {
          if (!settings || (settings && Object.keys(settings).length <= 0)) {
            setIsCssLoading(false);
          } else if (
            partner?.name !== '' &&
            newState.title === (settings?.displayName || partner?.name) &&
            addedTags?.linkTags &&
            removedTags?.linkTags &&
            // addedTags.linkTags?.length === 2 &&
            // !addedTags?.linkTags[1].nextSibling &&
            isCssLoading
          ) {
            setTimeout(() => setIsCssLoading(false), 1000);
          } else {
            setTimeout(() => setIsCssLoading(false), 2000);
          }
        }}
      >
        <meta name="theme-color" content={settings?.brand?.color || 'red'} />
        <link rel="stylesheet" href={`${settings?.customCSS}`} />
        <link rel="icon" href={`${settings?.brand?.favicon || GLOBAL_FAVICON}`} />
        <title>{`${settings?.displayName || partner?.name || GLOBAL_PARTNER}`}</title>
      </Helmet>
      {isCssLoading || isFetching ? <CentredSpinner size="80" className="loader" /> : <Main />}
    </div>
  );
};

export default Root;
